import { render, staticRenderFns } from "./detailPopup.vue?vue&type=template&id=89b8c034&scoped=true&"
import script from "./detailPopup.vue?vue&type=script&lang=js&"
export * from "./detailPopup.vue?vue&type=script&lang=js&"
import style0 from "./detailPopup.vue?vue&type=style&index=0&id=89b8c034&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b8c034",
  null
  
)

export default component.exports